const fetchWatches = async ({ rmcs, lang }, { env, locale }) => {
  // console.log("ENV: fetch watches", env)
  lang ??= locale.defaultLocale.codes.www
  const API_URL = process.browser ? env.services : process.env.SERVICE_CATALOG_URL

  // console.log("ymal- rmcs", rmcs)

  const rmcsString = `(${rmcs?.map(rmc => `"${rmc}"`).join(",")})`

  const url = new URL(`/api/catalog/watches?language=${lang}&rmc=${rmcsString}`, API_URL)
  const res = await fetch(new Request(url))
  const { results } = await res.json()
  const watches = rmcs
    ?.map(rmc => {
      return results.find(watch => watch.rmc === rmc)
    })
    .filter(Boolean)

  // console.log("ymal--fetch", { watches })

  return watches
}

const fetchRetailers = async ({ countryCode = "FR", langCode = "fr", latitude, longitude, onlyServiceCenter, uid }, { env }) => {
  const API_URL = process.browser ? env.retailers : process.env.RETAILERS_BASE_URL

  if (latitude && longitude) {
    const res = await fetch(
      `${API_URL}/app/establishments/search?context=rolexNearestNoDistance&lat=${latitude}&lng=${longitude}&establishmentType=${
        onlyServiceCenter ? "SERVICECENTER" : "STORE"
      }&brand=RLX&langCode=${langCode}&countryCode=${countryCode}}`
    )

    const retailers = await res.json()

    // only 5 retailers when using latitude/longitude and sorted by distanceValue
    return retailers.sort((a, b) => a.distanceValue - b.distanceValue).slice(0, 5)
  } else {
    const res = await fetch(
      `${API_URL}/app/establishments/light/jsFront?establishmentType=${
        onlyServiceCenter ? "SERVICECENTER" : "STORE"
      }&langCode=${langCode}&brand=RLX,RCPO&countryCode=${countryCode}&shuffleList=true&random=${uid || Math.random()}`
    )

    const retailers = await res.json()

    // 10 retailers when using country code
    return retailers.slice(0, 10)
  }
}

export { fetchRetailers, fetchWatches }
